import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {TSMap} from "typescript-map";
import Utils from "platform/util/Utils";
import {OnLoggedOut} from "core/redux/auth/AuthReduxActions";
import Platform from "platform/Platform";
import {ServiceType} from "enum/ServiceType";
import {LessonsReduxState} from "core/redux/lessons/LessonsReduxState";
import LessonsEngine from "core/engine/LessonsEngine";
import {
    FetchUIConfigurationType,
    OptInLessonType, RequestEnableEbookType,
    SetLesson,
    SetLessonPayload,
    SetLessons,
    SetLessonsPayload
} from "core/redux/lessons/LessonsReduxActions";
import {Lesson} from "protocol/config/GetUIConfigurationResponse";

const initialState = (): LessonsReduxState => {
    return {
        categories: [],
        lessons: new TSMap<number, Lesson[]>(),
        lesson: null,
        EbookUrl: null
    };
};

export default class LessonsReducer extends Reducer<LessonsReduxState> {

    private static _instance: LessonsReducer;

    public static instance(): LessonsReducer {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        super();
        const lessonsEngine: LessonsEngine = Platform.engine(ServiceType.Lessons);
        this._middlewareActions.set(FetchUIConfigurationType, lessonsEngine.doFetchUIConfiguration);
        this._middlewareActions.set(OptInLessonType, lessonsEngine.doOptInLesson);
        this._middlewareActions.set(RequestEnableEbookType, lessonsEngine.doRequestEnableEbook);
    }

    public get name(): string {
        return "lessons";
    }

    protected setup(builder: ReducerBuilder<LessonsReduxState>): void {
        builder
            .init(initialState())
            .handle(OnLoggedOut, (state: LessonsReduxState, action: Action<any>) => {
                return {
                    ...initialState()
                };
            })
            .handle(SetLessons, (state: LessonsReduxState, {payload}: Action<SetLessonsPayload>) => {
                const newState: LessonsReduxState = Utils.merge({}, state);
                newState.categories = payload.categories;
                newState.lessons = payload.lessons;
                newState.EbookUrl = payload.EbookUrl;
                return newState;
            })
            .handle(SetLesson, (state: LessonsReduxState, {payload}: Action<SetLessonPayload>) => {
                const newState: LessonsReduxState = Utils.merge({}, state);
                newState.lesson = payload.lesson;
                return newState;
            });
    }
}
